import React from 'react'
import CSSModules from 'helpers/CSSModulesUtil'
import Dialog from 'react-toolbox/lib/dialog';
import LifecycleStateInfo from './LifecycleStateInfo'
import T from 'i18n-react'
import styles from './styles.scss'
import Divider from 'components/fulcrum/divider/Divider'

const InfoDialog = (props) => {
  return (
    <Dialog 
      active={props.active}
      onEscKeyDown={props.toggleActive}
      onOverlayClick={props.toggleActive}
      actions={[{label: "Close", onClick: props.toggleActive}]}
      title={T.translate('project.lifecycle.dialog.title')}
      theme={styles}
    >
      <div styleName='container'>
        <Divider styleName='topDivider'/>
        {props.lifecycleHistory.slice(0).reverse().map((lifecycleState, index) => {
          return(
            <LifecycleStateInfo data={lifecycleState} key={index} />
          )
        })}
      </div>
    </Dialog>
  )
}

export default CSSModules(styles)(InfoDialog)
